import { render, staticRenderFns } from "./asideForm.vue?vue&type=template&id=3761cdee&scoped=true"
import script from "./asideForm.vue?vue&type=script&lang=js"
export * from "./asideForm.vue?vue&type=script&lang=js"
import style0 from "./asideForm.vue?vue&type=style&index=0&id=3761cdee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3761cdee",
  null
  
)

export default component.exports